import { createContext } from "react";

export const QuoteDataContext = createContext()



